import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// import enUS from './locales/en-US.translation.json'
import zhTW from './locales/zh-TW.translation.json'

i18n.use(initReactI18next).init({
  lng: 'zhTW',
  fallbackLng: 'zhTW',
  resources: {
    // enUS: {
    //   translation: enUS,
    // },
    zhTW: {
      translation: zhTW,
    },
  },
  debug: false,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
